module.exports = __webpack_public_path__ + "7e0b1982cfa8bec38886c8456822a2b7.png";